import { aboutLandingHeroConfig } from '@src/components/sco/LayoutBlocks/Hero/configs/aboutLanding'
import { educationLandingHeroConfig } from '@src/components/sco/LayoutBlocks/Hero/configs/educationLanding'
import { eventsLandingHeroConfig } from '@src/components/sco/LayoutBlocks/Hero/configs/eventsLanding'
import { investorMatchingLandingHeroConfig } from '@src/components/sco/LayoutBlocks/Hero/configs/investorMatchingLanding'
import { memberMatchingLandingHeroConfig } from '@src/components/sco/LayoutBlocks/Hero/configs/memberMatchingLanding'
import { proLandingHeroConfig } from '@src/components/sco/LayoutBlocks/Hero/configs/proLanding'
import { proTrialLandingHeroConfig } from '@src/components/sco/LayoutBlocks/Hero/configs/proTrialLanding'
import { requestsLandingHeroConfig } from '@src/components/sco/LayoutBlocks/Hero/configs/requestsLanding'
import { successLandingHeroConfig } from '@src/components/sco/LayoutBlocks/Hero/configs/successLanding'
import type { HeroConfig } from '@src/components/sco/LayoutBlocks/Hero/types'
export type HeroConfigKey =
  | 'educationLanding'
  | 'eventsLanding'
  | 'requestsLanding'
  | 'investorMatchingLanding'
  | 'memberMatchingLanding'
  | 'successLanding'
  | 'aboutLanding'
  | 'proLanding'
  | 'proTrialLanding'

export const HERO_CONFIGS: Record<HeroConfigKey, HeroConfig> = {
  educationLanding: educationLandingHeroConfig,
  eventsLanding: eventsLandingHeroConfig,
  requestsLanding: requestsLandingHeroConfig,
  investorMatchingLanding: investorMatchingLandingHeroConfig,
  memberMatchingLanding: memberMatchingLandingHeroConfig,
  successLanding: successLandingHeroConfig,
  aboutLanding: aboutLandingHeroConfig,
  proLanding: proLandingHeroConfig,
  proTrialLanding: proTrialLandingHeroConfig,
}

export function getHeroConfig(key: HeroConfigKey): HeroConfig {
  return HERO_CONFIGS[key]
}
